import { KeyRoot } from '../types/enums';

const defaultDesktopWidth = 420; // nice
const draggableZoneRadius = 48;

export const TempoFilterConfig = {
    DraggableZoneRadius: draggableZoneRadius,
    ButtonRadius: 12,
    MinSliderPosX: 0,
    MaxSliderPosX: defaultDesktopWidth,
    MinBpm: 40,
    InitialMaxBpm: 120,
    MaxBpm: 240,
};

export const FlatKeyNotes = [
    KeyRoot.C,
    KeyRoot.Db,
    KeyRoot.D,
    KeyRoot.Eb,
    KeyRoot.E,
    KeyRoot.F,
    KeyRoot.Gb,
    KeyRoot.G,
    KeyRoot.Ab,
    KeyRoot.A,
    KeyRoot.Bb,
    KeyRoot.B,
];

export const SharpKeyNotes = [
    KeyRoot.C,
    KeyRoot.Csharp,
    KeyRoot.D,
    KeyRoot.Dsharp,
    KeyRoot.E,
    KeyRoot.F,
    KeyRoot.Fsharp,
    KeyRoot.G,
    KeyRoot.Gsharp,
    KeyRoot.A,
    KeyRoot.Asharp,
    KeyRoot.B,
];
